import React from 'react';
import { CloseableModal } from '../../../../../../../../../components/CloseableModal';
import { DisconnectedIntegrationModalBody } from '../../../../../../../../../components/DisconnectedIntegrationModalBody';
import { appendQueryParam } from '../../../../../../../../../utils/url';

interface PropTypes {
  setIsSchedulingModalOpen: (isOpen: boolean) => void;
  isSchedulingModalOpen: boolean;
}

export function SchedulingIntegrationModalContent(props: PropTypes) {
  return (
    <CloseableModal
      className='modal-dialog-centered'
      onClose={() => props.setIsSchedulingModalOpen(false)}
      isOpen={props.isSchedulingModalOpen}
      size='md'
      closeDisabled={false}
      keyboard={true}
      backdrop={true}
      headerTitle={'Calendar Integration Disconnected'}
      bodyChildren={
        <DisconnectedIntegrationModalBody
          largeImage
          url={appendQueryParam(
            '/account_settings/integrations',
            'state',
            window.location.href,
          )}
          onClose={() => props.setIsSchedulingModalOpen(false)}
          informationText='Your calendar got disconnected, so scheduling is on pause for now.'
          actionText='Just reconnect to pick up where you left off.'
        />
      }
    />
  );
}
